import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import { useRouter } from "next/router";
import React, { FC } from "react";

import styles from "./styles.module.scss";

const Heading: FC = () => {
  const router = useRouter();

  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <div className={styles.content}>
        <Label color="primary" variant="h" className={styles.title}>
          We have $1,000 with your name on it!
        </Label>
        <Label color="primary" variant="s" className={styles.subtitle}>
          Give 1 month free, get $1,000. Humming Homes referral program makes it
          easy to recommend the best service and put $ in your pocket.
        </Label>
        <Button
          variant="accent"
          className={styles.button}
          onClick={() => router.push("refer/#share")}
        >
          Refer now
        </Button>
      </div>
    </Content>
  );
};

export default Heading;
